export default __webpack_public_path__ + "static/media/decada-0090-0005-min.d1df2fdd.jpg";